import {Injectable} from '@angular/core';
import {LOCALSTORAGE_KEY_LIST_HELP, OPTION_TYPE} from '../../defines/client.const';


export enum LIST_HELP_FLAG {
  ABOUT,
  LARGE_FONT,
  AUTO_PLAY,
  SEARCH,
  START_ANIM,
  JASO_BTN,
  // HISTORY_BTN, // TODO: 나중에 추가하는 것을 고려.
  RECORD_BTN,
}

export enum LIST_HELP_TYPE {
  HELP,   // board의 내용을 표시하는 것을 의미
  OPTION,
}

export type LIST_HELP_ITEM = {
  flag: LIST_HELP_FLAG, // 이 도움말의 flag (다시 표시 되지 않도록 처리하는 flag 값)
  type: LIST_HELP_TYPE;
  content: number | OPTION_TYPE;  // LIST_HELP_TYPE.HELP인 경우에는 게시판 번호(number), LIST_HELP_TYPE.OPTION인 경우에는 OPTION_TYPE이다.
  check: (type: unknown, count: number) => boolean; // 이 도움말이 표시되는 조건을 체크하는 함수
  priority: number;
  comment?: string;
};

const ONLY_ONE = (type: unknown, count: number) => {
  return count < 1;
};

const listHelpItems: Array<LIST_HELP_ITEM> = [
  // {
  //   flag: LIST_HELP_FLAG.ABOUT,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 1,
  //   check: (type: unknown, count: number) => true,
  //   priority: 100,  // 무조건적, 최우선으로 출력
  // },
  {
    flag: LIST_HELP_FLAG.LARGE_FONT,
    type: LIST_HELP_TYPE.OPTION,
    content: OPTION_TYPE.LARGE_MODE,
    check: (type: unknown, count: number) => {
      return count < 2;
    },
    priority: 1,
    comment: "우 상단의 '글씨 크게 보기'에서 혹은 '설정'에서 바꿀 수 있습니다.",
  },
  {
    flag: LIST_HELP_FLAG.AUTO_PLAY,
    type: LIST_HELP_TYPE.OPTION,
    content: OPTION_TYPE.AUTO_PLAY,
    check: ONLY_ONE,
    priority: 1,
  },
  // {
  //   flag: LIST_HELP_FLAG.SEARCH,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 5,
  //   check: ONLY_ONE,
  //   priority: 1,
  // },
  // {
  //   flag: LIST_HELP_FLAG.START_ANIM,
  //   type: LIST_HELP_TYPE.OPTION,
  //   content: OPTION_TYPE.START_ANIM,
  //   check: ONLY_ONE,
  //   priority: 1,
  // },
  // {
  //   flag: LIST_HELP_FLAG.JASO_BTN,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 7,
  //   check: ONLY_ONE,
  //   priority: 1,
  // },
  // {
  //   flag: LIST_HELP_FLAG.RECORD_BTN,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 8,
  //   check: ONLY_ONE,
  //   priority: 1,
  // },
];



@Injectable({
  providedIn: 'root'
})
export class ListHelpService {
  // JSON으로 변환되어서 저장되는 변수. 도움말을 닫으면 더 이상 안 보이도록 처리하는데 사용됨.
  private flags: Set<number> | null = null;

  constructor() {
    this.load();
  }

  public reset(): void {
    this.flags = new Set<number>();
    this.save();
  }

  GetListHelp(type: unknown): Array<LIST_HELP_ITEM> {
    let count = 0;
    const listHelp = listHelpItems.filter(item => {
      const ret = !this.flags?.has(item.flag) && item.check(null, count);
      if (ret) {
        ++count;
      }
      return ret;
    }).sort((a, b) => b.priority - a.priority);

    if (listHelp.length === 0) {
      this.reset();
    }

    return listHelp;
  }

  public SetFlag(type: LIST_HELP_FLAG): void {
    this.flags?.add(type);
    this.save();
    // console.log('SetFlag()', type, this.flags);
  }

  toJSON(): any {
    return {
      flags: Array.from(this.flags || []),
    };
  }

  public load(): void {
    const txtOptions = localStorage.getItem(LOCALSTORAGE_KEY_LIST_HELP);
    const json = txtOptions ? JSON.parse(txtOptions) : null;

    this.flags = new Set<number>(json && 'flags' in json ? json.flags : []);

    console.log('ListHelpService::load()', this);
  }

  public save(): void {
    localStorage.setItem(LOCALSTORAGE_KEY_LIST_HELP, JSON.stringify(this));
  }
}
